import React from "react";
export const PictagsContext = React.createContext();
